import React, { useState, useRef, useEffect } from "react";
import { TextField } from '@fluentui/react/lib/TextField';
import { DetailsHeader, DetailsListLayoutMode, Selection, SelectionMode, ConstrainMode } from '@fluentui/react/lib/DetailsList';
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap"
import { ShimmeredDetailsList } from '@fluentui/react/lib/ShimmeredDetailsList';
import { IconButton } from '@fluentui/react/lib/Button';
import { OverflowSet } from '@fluentui/react/lib/OverflowSet';
import { getTheme, mergeStyles } from '@fluentui/react/lib/Styling';
import { fieldSorter, getGlobalListPageSize, isValidDate } from "../../../common/Helpers";
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../common/CommonFuctions';
import moment from "moment";

function base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64); // Comment this if not using base64
    const bytes = new Uint8Array(binaryString.length);
    return bytes.map((byte, i) => binaryString.charCodeAt(i));
}



export default function List(props) {
    const { t } = useTranslation();

    const linkExport = useRef();

    const entityData = props.data;
    const inputParam_SetData = props.setData !== undefined && props.setData !== null ? props.setData : null;
    const handleExport = props.handleExport;
    const enableExport = props.enableExport !== undefined && props.enableExport !== null ? props.enableExport : false;
    const listLocalStoragePageSizeVariableName = props.listLocalStoragePageSizeVariableName !== undefined && props.listLocalStoragePageSizeVariableName !== null ? props.listLocalStoragePageSizeVariableName : null;
    const inputParam_ShowHeaders = props.showHeaders !== undefined && props.showHeaders !== null ? props.showHeaders : true;
    const inputParam_IsHeaderVisible = props.isHeaderVisible !== undefined && props.isHeaderVisible !== null ? props.isHeaderVisible : true;
    const inputParam_ClassName = props.className !== undefined && props.className !== null ? props.className : "";
    const inputParam_Styles = props.inputParam_Styles !== undefined && props.inputParam_Styles !== null ? props.inputParam_Styles : {root: { zIndex: -2 }};
    const aux_columns = props.columns;
    const exportFileName = props.exportFileName;
    const inputParam_Key = props.key !== undefined && props.key !== null ? props.key : undefined;
    const inputParam_OnRenderRow = props.inputParam_OnRenderRow !== undefined && props.inputParam_OnRenderRow !== null ? props.inputParam_OnRenderRow : undefined;

    const iconButtonStyles = { root: { float: 'left', height: 'inherit', padding: '10px' } };
   

    const inputParam_ManipulateLocalData = props.manipulateLocalData !== null && props.manipulateLocalData !== undefined ? props.manipulateLocalData : false;
    //const inputParam_SetLocalData = props.setLocalData !== null && props.setLocalData !== undefined ? props.setLocalData : null;


    const [localData, setLocalData] = useState({
        data: null,
        orderAsc: null,
        orderField: null,
        pageNumber: 1,
        pageSize: getGlobalListPageSize(listLocalStoragePageSizeVariableName),
        totalPages: 1,
        totalRecords: 0,
        filters: []
    });

    const paginate = (arr, size) => {
        return arr.reduce((acc, val, i) => {
            let idx = Math.floor(i/size)
            let page = acc[idx] || (acc[idx] = [])
            page.push(val)

            return acc
        }, [])
    }
 
    useEffect(()=> {
        const getData = async () => {
            try {
                inputParam_SetData && inputParam_SetData(prevState => ({
                    ...prevState,
                    totalPages: Math.ceil(entityData.data.length / entityData.pageSize),
                    totalRecords: entityData.data.length,
                    fireUpdate: false,
                }))

                setLocalData({
                    data: paginate(entityData.data, entityData.pageSize)[entityData.pageNumber-1],
                    pageNumber: entityData.pageNumber,
                    pageSize: entityData.pageSize,
                    filters: [],
                    totalPages: Math.ceil(entityData.data.length / entityData.pageSize),
                    totalRecords: entityData.data.length,
                    fireUpdate: false,
                })
            }
            catch (error) {
            }
        }
        
        if (entityData.data !== null && entityData.fireUpdate === true && inputParam_ManipulateLocalData) {
            getData()
        }
    }, [entityData, inputParam_ManipulateLocalData, entityData.fireUpdate, entityData.pageNumber, entityData.pageSize, inputParam_SetData]);

    const Download = (base64FFile, type) => {
        const arrayBuffer = base64ToArrayBuffer(base64FFile);
    
        let blob = new Blob([arrayBuffer], { type: type });
        let url = URL.createObjectURL(blob);
        let fileName = (t('data-lang-export-file-name') +"_"+ moment(new Date()).format("DD_MM_YYYY_HH_mm_ss")).replaceAll(" ", "_");
        linkExport.current.href = (url);
        linkExport.current.download = exportFileName !== null || exportFileName !== undefined ? exportFileName.replaceAll(" ", "_") : fileName;
        linkExport.current.click();
    }
    
    const _onColumnClick = (ev, column) => {
        const newColumns = _columns.slice();
        let currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        if (inputParam_ManipulateLocalData) {

            if (column.key !== "id") {
                const arrayFiltersLocals = [];
            
                _columns.forEach((newCol) => {
                    if (newCol === currColumn) {
                        let colOrder = currColumn.fieldName === localData.orderField ? !localData.orderAsc : column.isSortedDescending;
                        arrayFiltersLocals.push(`${colOrder ? '-' : ''}${currColumn.fieldName}`);
                        const aux_NewlocalData = localData.data.sort(fieldSorter(arrayFiltersLocals));
    
                        setLocalData(prevState => ({
                            ...prevState,
                            pageNumber: 1,
                            orderAsc: colOrder,
                            orderField: currColumn.fieldName,
                            data: aux_NewlocalData
                        }));
                    }
                    else {
                        newCol.isSorted = false;
                        newCol.isSortedDescending = false;
                    }
                });
            }
        }
        else {
            newColumns.forEach((newCol) => {
                if (newCol === currColumn) {
                    currColumn.isSortedDescending = !currColumn.isSortedDescending;
                    currColumn.isSorted = true;
                }
                else {
                    newCol.isSorted = false;
                    newCol.isSortedDescending = null;
                }
            });

            inputParam_SetData && inputParam_SetData(prevState => ({
                ...prevState,
                data: null,
                pageNumber: 1,
                orderAsc: currColumn.isSortedDescending,
                orderField: currColumn.fieldName
            }));
        }

        //setColumns(newColumns);
        _columns = newColumns;
    }

    const renderDetailsHeader = (detailsHeaderProps) => {
        return (<DetailsHeader {...detailsHeaderProps} onRenderColumnHeaderTooltip={renderCustomHeaderTooltip} />);
    }

    const renderCustomHeaderTooltip = (tooltipHostProps) => {
        let column = (tooltipHostProps).column;

        if ((column === undefined || column.key === "id")) {

            let filterActions = [];
            
            if ((inputParam_ManipulateLocalData ?  localData.filters.length : entityData.filters.length) === 0) {
                filterActions = [
                    {
                        key: 'item1',
                        icon: "Filter",
                        name: t('data-lang-btn-filter'),
                        title: t('data-lang-btn-filter'),
                        onClick: () => ((inputParam_ManipulateLocalData ?  localData.filters.length : entityData.filters.length) === 0) ? null : handleFilter(),
                    }
                ];
            }
            else {
                filterActions = [
                    {
                        key: 'item1',
                        icon: "Filter",
                        name: t('data-lang-btn-filter'),
                        title: t('data-lang-btn-filter'),
                        onClick: () => handleFilter(),
                    },
                    {
                        key: 'item2',
                        icon: "RemoveFilter",
                        name: t('data-lang-btn-filterclear'),
                        title: t('data-lang-btn-filterclear'),
                        onClick: () => handleClearFilter(),
                    }
                ]
            }

            return (
                <div className="text-center">
                    <span>{tooltipHostProps.children}</span>
                    <div className="d-flex float-end" style={{padding: 0, margin: 0}}>
                        <div style={{padding: 0, margin: 0}}>
                            <OverflowSet
                                className="action-menu-list-toolbar d-flex justify-content-center"
                                role="menubar"      
                                items={filterActions}
                                onRenderOverflowButton={__onRenderOverflowButton}
                                onRenderItem={__onRenderOverflowItem}
                            />
                        </div>
                        {enableExport && 
                            <div style={{padding: 0, margin: 0}}>
                                <IconButton
                                    menuIconProps={{ iconName: 'MoreVertical' }}
                                    role="button"
                                    className="action-menu-list-toolbar"
                                    aria-haspopup
                                    styles={iconButtonStyles}
                                    menuProps={{
                                        items: [
                                            {
                                                key: 'export',
                                                iconProps: { iconName: 'ExcelLogo' },
                                                text: t('data-lang-btn-exportexcel'),
                                                onClick: () => handleExport(Download, JSON.stringify(aux_columns.map(col => col.fieldName + "[|]" + col.name))),
                                            },
                                        ],
                                    }}
                                />
                            </div>
                        }

                    </div>
                </div>
            );
        }
        else {

            let arr = inputParam_ManipulateLocalData ?  localData.filters : entityData.filters;
            let filter = arr.find(x => x.field === column.key);
            let auxValue = filter !== null && filter !== undefined ? filter.value : "";

            return (
                <div className={tooltipHostProps.hostClassName}>
                    <Row>
                        <Col>
                            <span>{tooltipHostProps.children}</span>
                        </Col>
                    </Row>
                    {column.key.indexOf("nofilter_") !== 0 &&                    
                        <Row>
                            <Col>
                            <TextField
                                placeholder={`${t('data-lang-btn-filter')}:  ${ column.key.indexOf("all-props-") !== -1 ? t("all-props") : t(column.fieldName) }`}
                                onChange={(event) => onFilterChange(event, column.key)}
                                onKeyDown={ handleKeyPress }
                                value={auxValue}
                                name={column.fieldName}
                                ref={column.fieldName} 
                                autoComplete="off"
                                />
                            </Col>
                        </Row>
                    }
                </div>
            );
        }
    };
/*<TextField
placeholder={`${t('data-lang-btn-filter')}:  ${ column.key.indexOf("all-props-") !== -1 ? t("all-props") : t(column.fieldName) }`}
onChange={(event) => onFilterChange(event, column.key)}
value={auxValue}
name={column.fieldName}
ref={column.fieldName} 
autoComplete="off"
/>*/
/*<TextField
placeholder={t('data-lang-btn-filter')}
onChange={(event) => onFilterChange(event, column.key)}
value={auxValue}
name={column.key}
ref={column.key} 
autoComplete="off"
/>*/
    const handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            handleFilter();
        }
    }

    const onFilterChange = (event, field) => {
        let textFilter = event.currentTarget.value;

        let listFilters = inputParam_ManipulateLocalData ?  localData.filters : entityData.filters;

        let elementFound = false;
        listFilters.forEach(element => {
            if(element.field === field) {
                elementFound = true;
                element.value = textFilter;
            }
        });

        if (elementFound === false) {
            listFilters.push({field: field, value: textFilter})
        }

        if (inputParam_ManipulateLocalData) {
            setLocalData(prevState => ({
                ...prevState,
                filters: listFilters
            }));
        } else {
            inputParam_SetData && inputParam_SetData(prevState => ({
                ...prevState,
                filters: listFilters
            }));
        }

    }

    const handleFilter = async () => {
        if (inputParam_ManipulateLocalData) {

            let results = [];
            let resultsByProps = [];
            let resultsAllProps = [];

            localData.filters.forEach(element => {
                if (element.field.indexOf("all-props-") === -1) {
                    if (resultsByProps.length === 0) {
                        for(let i = 0; i < entityData.data.length; i++) {
                            let elemvalue = element.value.toString().toLowerCase();
                            let keyData = (entityData.data[i][element.field].toString().indexOf('data-lang-') !== -1 ?  t(entityData.data[i][element.field].toString()) : entityData.data[i][element.field]).toString().toLowerCase().indexOf(elemvalue);
    
                            if(keyData !== -1) {
                                const duplicated = resultsByProps.find(x => x.id === entityData.data[i].id);
                                if(duplicated === null || duplicated === undefined) {
                                    resultsByProps.push(entityData.data[i]);
                                }
                            }
                            else {
                                const isValidDateResult = isValidDate(entityData.data[i][element.field]);

                                if (isValidDateResult) {
                                    const formatedDate = moment(new Date(entityData.data[i][element.field])).format("DD/MM/YYYY");

                                    if (formatedDate.indexOf(elemvalue) !== -1) {
                                        const duplicated = resultsByProps.find(x => x.id === entityData.data[i].id);
                                        if(duplicated === null || duplicated === undefined) {
                                            resultsByProps.push(entityData.data[i]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else {
                        const aux_array = [];
                        for(let k = 0; k < resultsByProps.length; k++) {
                            let value = element.value.toString().toLowerCase();
                            let key = (resultsByProps[k][element.field].indexOf('data-lang-') !== -1 ? t(resultsByProps[k][element.field]) : resultsByProps[k][element.field]).toString().toLowerCase().indexOf(value);
    
                            if(key !== -1) {
                                aux_array.push(entityData.data[k]);
                            }
                        }

                        resultsByProps = aux_array;
                    }
                }
                else {
                    for(let j = 0; j < entityData.data.length; j++) {
                        let keyAll = Object.keys(entityData.data[j]).map(key => entityData.data[j][key] !== null ?
                            entityData.data[j][key].toString().indexOf('data-lang-') !== -1 ? t(entityData.data[j][key]) : entityData.data[j][key] : "").join('|') ;
                        
                        if(keyAll.toString().toLowerCase().indexOf(element.value.toString().toLowerCase()) !== -1) {
                            const duplicated = resultsByProps.find(x => x.id === entityData.data[j].id);
                            if(duplicated === null || duplicated === undefined) {
                                resultsAllProps.push(entityData.data[j]);
                            }
                        } 
                    }
                }
            });

            if (resultsAllProps.length > 0 && resultsByProps.length > 0) {
                resultsByProps.forEach(element1 => {
                    for (let index = 0; index < resultsAllProps.length; index++) {
                        const element2 = resultsAllProps[index];
                        if (element1.id === element2.id) {
                            const duplicated = results.find(x => x.id === element2.id);
                            if(duplicated === null || duplicated === undefined) {
                                results.push(element2);
                                break;
                            }
                        }
                    }
                });
            }
            else if (resultsAllProps.length > 0 && resultsByProps.length === 0) {
                for (let index = 0; index < resultsAllProps.length; index++) {
                    const element2 = resultsAllProps[index];
                        const duplicated = results.find(x => x.id === element2.id);
                        if(duplicated === null || duplicated === undefined) {
                            results.push(element2);
                        }
                }
            }
            else if (resultsAllProps.length === 0 && resultsByProps.length > 0) {
                for (let index = 0; index < resultsByProps.length; index++) {
                    const element2 = resultsByProps[index];
                        const duplicated = results.find(x => x.id === element2.id);
                        if(duplicated === null || duplicated === undefined) {
                            results.push(element2);
                        }
                }
            }
            else if (resultsAllProps.length === 0 && resultsByProps.length === 0) {
                results = [];
            }

            setLocalData(prevState => ({
                ...prevState,
                //Hacer los filtros locales bien.
                data:  results,
                totalPages: Math.ceil(results.length / entityData.pageSize),
                pageNumber: 1,
            }));
        }
        else {
            inputParam_SetData && inputParam_SetData(prevState => ({
                ...prevState,
                data: null
            }));
        }
    }
    
    const handleClearFilter = async () => {
        if (inputParam_ManipulateLocalData) {
            setLocalData(prevState => ({
                ...prevState,
                data: paginate(entityData.data, entityData.pageSize)[0],
                totalPages: Math.ceil(entityData.data.length / entityData.pageSize),
                filters: [],
                pageNumber: 1,
            }));
        }
        else {
            inputParam_SetData && inputParam_SetData(prevState => ({
                ...prevState,
                data: null,
                filters: []
            }));
        }
    }
    
    /*const [_columns, setColumns] = useState(aux_columns.map((item, index) => {
        if (item.onRender !== undefined) {
            return {
                key: item.key,
                name: item.name,
                fieldName: item.fieldName,
                minWidth: item.minWidth,
                maxWidth: item.maxWidth,
                isResizable: true,
                isSorted: true,
                isSortedDescending: false,
                onColumnClick: _onColumnClick,
                onRender: item.onRender
            }
        }
        else {
            return {  
                key: item.key,
                name: item.name,
                fieldName: item.fieldName,
                minWidth: item.minWidth,
                maxWidth: item.maxWidth,
                isResizable: true,
                isFiltered: false,
                isSorted: true,
                isSortedDescending: false,
                onColumnClick: _onColumnClick,
            }
        }
    }));*/
    let _columns = aux_columns.map((item, index) => {
        if (item.onRender !== undefined) {
            return {
                key: item.key,
                name: item.name,
                fieldName: item.fieldName,
                minWidth: item.minWidth,
                maxWidth: item.maxWidth,
                isResizable: true,
                isSorted: item.key === "id" ? false : (inputParam_ManipulateLocalData ? (localData.orderField === item.fieldName ? true : false) : false),
                isSortedDescending: item.key === "id" ? false : (inputParam_ManipulateLocalData ? (localData.orderField === item.fieldName ? localData.orderAsc : false) : false),
                onColumnClick: _onColumnClick,
                onRender: item.onRender
            }
        }
        else {
            return {  
                key: item.key,
                name: item.name,
                fieldName: item.fieldName,
                minWidth: item.minWidth,
                maxWidth: item.maxWidth,
                isResizable: true,
                isFiltered: false,
                isSorted: item.key === "id" ? false : (inputParam_ManipulateLocalData ? (localData.orderField === item.fieldName ? true : false) : false),
                isSortedDescending: item.key === "id" ? false : (inputParam_ManipulateLocalData ? (localData.orderField === item.fieldName ? localData.orderAsc : false) : false),
                onColumnClick: _onColumnClick,
            }
        }
    });

    let _draggedItem = undefined;
    let _draggedIndex = -1;
    const dragState = {
        isColumnReorderEnabled: true,
        frozenColumnCountFromStart: '1',
        frozenColumnCountFromEnd: '1',
    };

    const theme = getTheme();
    //const dragEnterClass = mergeStyles({
    //    backgroundColor: theme.palette.neutralLight,
    //});

    let _selection = new Selection();

    const _handleColumnReorder = (draggedIndex, targetIndex) => {
        const draggedItems = _columns[draggedIndex];
        const newColumns = [..._columns];
    
        // insert before the dropped item
        newColumns.splice(draggedIndex, 1);
        newColumns.splice(targetIndex, 0, draggedItems);

        //setColumns(newColumns);
        _columns = newColumns;
    };

    const _getColumnReorderOptions = () => {
        return {
          frozenColumnCountFromStart: parseInt(dragState.frozenColumnCountFromStart, 10),
          frozenColumnCountFromEnd: parseInt(dragState.frozenColumnCountFromEnd, 10),
          handleColumnReorder: _handleColumnReorder,
        };
    }

    const _insertBeforeItem = (item) => {
        const draggedItems = _selection.isIndexSelected(_draggedIndex)
          ? (_selection.getSelection())
          : [!_draggedItem];
    
        const insertIndex = inputParam_ManipulateLocalData ? localData.data.indexOf(item) : entityData.data.indexOf(item);
        const items = inputParam_ManipulateLocalData ? localData.data.filter(itm => draggedItems.indexOf(itm) === -1) : entityData.data.filter(itm => draggedItems.indexOf(itm) === -1);
    
        items.splice(insertIndex, 0, ...draggedItems);
    
        if (inputParam_ManipulateLocalData) {
            setLocalData(prevState => ({
                ...prevState,
                data: items,
            }));
        } else {
            inputParam_SetData && inputParam_SetData(prevState => ({
                ...prevState,
                data: items,
            }));
        }


    }

    /*const _getDragDropEvents = () => {
        return {
          canDrop: (dropContext, dragContext) => {
            return true;
          },
          canDrag: (item) => {
            return true;
          },
          onDragEnter: (item, event) => {
            // return string is the css classes that will be added to the entering element.
            return dragEnterClass;
          },
          onDragLeave: (item, event) => {
            return;
          },
          onDrop: (item, event) => {
            if (_draggedItem) {
              _insertBeforeItem(item);
            }
          },
          onDragStart: (item, itemIndex, selectedItems, event) => {
            _draggedItem = item;
            _draggedIndex = !itemIndex;
          },
          onDragEnd: (item, event) => {
            _draggedItem = undefined;
            _draggedIndex = -1;
          },
        };
    }*/

    //const _dragDropEvents = _getDragDropEvents();

    return (
        <div className="col-12 listWithActions">
                <a href="/" style={{display: "none"}} ref={linkExport} >#</a>
                {
                    (inputParam_ManipulateLocalData ? localData.data !== null : entityData.data !== null) ?
                    <ShimmeredDetailsList
                        key={inputParam_Key}
                        items={ inputParam_ManipulateLocalData ? localData.data : entityData.data || [] }
                        setKey="set"
                        columns={_columns}
                        selection={_selection}
                        selectionMode={SelectionMode.none}
                        layoutMode={DetailsListLayoutMode.justified}
                        enableShimmer={ inputParam_ManipulateLocalData ? !localData.data : !entityData.data }
                        constrainMode={ConstrainMode.horizontalConstrained}
                        //dragDropEvents={_dragDropEvents}
                        className={inputParam_ClassName}
                        onRenderDetailsHeader={inputParam_ShowHeaders ? renderDetailsHeader : null}
                        isHeaderVisible={inputParam_IsHeaderVisible}
                        columnReorderOptions={ dragState.isColumnReorderEnabled ? _getColumnReorderOptions() : undefined}
                        styles={inputParam_Styles}
                        onRenderRow={inputParam_OnRenderRow}
                    /> : <></>
                }
                    
                
        </div>
    ); 
}